import axios from 'axios';

// Smart default: if no env is provided, use the current host with backend port 5000.
// This makes mobile/LAN testing work out of the box when you open http://<PC-IP>:3000
const inferredBase = (typeof window !== 'undefined')
  ? `http://${window.location.hostname}:5000/api`
  : 'http://localhost:5000/api';

const envBase = process.env.REACT_APP_API_URL;
const isLocalhostEnv = envBase ? /localhost|127\.0\.0\.1/i.test(envBase) : false;
const isLocalHostPage = (typeof window !== 'undefined') ? /^(localhost|127\.0\.0\.1)$/i.test(window.location.hostname) : true;
// If env points to localhost but the page is opened via a LAN IP, prefer inferredBase.
const resolvedBase = (envBase && !(isLocalhostEnv && !isLocalHostPage)) ? envBase : inferredBase;

const api = axios.create({
  baseURL: resolvedBase,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default api;